import navigation from "@/data/navigation";
import { DropdownType } from "@/types/navigation";
import Link from "next/link";
import { usePathname } from "next/navigation";
import MegaDropdown from "./mega-dropdown";

const renderDropdown = (dropdown: DropdownType[]) => {
    return (
        <ul className="sub-menu">
            {dropdown.map((item, i) => (
                <li
                    key={i}
                    className={item.dropdown ? "menu-item-has-children" : ""}
                >
                    <Link
                        className={item.dropdown ? "no-border" : ""}
                        href={item.href || "#"}
                    >
                        {item.label}
                    </Link>
                    {item.dropdown && renderDropdown(item.dropdown)}
                </li>
            ))}
        </ul>
    );
};

const Nav = () => {
    const pathname = usePathname();
    
    // Function to check if a navigation item is active
    const isActive = (href: string) => {
        if (href === "#") return false;
        
        // For exact matches
        if (pathname === href) return true;
        
        // For service pages - check if current path starts with service
        if (href === "/service" && pathname.startsWith("/service")) return true;
        
        // For blog pages - check if current path starts with blog
        if (href === "/blog" && pathname.startsWith("/blog")) return true;
        
        // For portfolio pages - check if current path starts with portfolio
        if (href === "/portfolio" && pathname.startsWith("/portfolio")) return true;
        
        return false;
    };

    return (
        <>
            <nav className="main-menu menu-style1 d-none d-lg-block">
                <ul>
                    {navigation?.map((item, i) =>
                        item.isMegaDropdown || item.dropdown ? (
                            <li key={i} className="menu-item-has-children">
                                <Link 
                                    href={item?.href || "#"}
                                    className={isActive(item.href || "") ? "active" : ""}
                                >
                                    {item.label}
                                    <svg 
                                        className="dropdown-arrow" 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="25" 
                                        height="24" 
                                        viewBox="0 0 25 24" 
                                        fill="none"
                                    >
                                        <path 
                                            d="M6.85938 9L12.8594 15L18.8594 9" 
                                            stroke="currentColor" 
                                            strokeWidth="2" 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                                {item.isMegaDropdown ? (
                                    <MegaDropdown dropdown={item} />
                                ) : (
                                    item.dropdown && renderDropdown(item.dropdown)
                                )}
                            </li>
                        ) : (
                            <li key={i}>
                                <Link 
                                    href={item.href || "#"}
                                    className={isActive(item.href || "") ? "active" : ""}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        )
                    )}
                </ul>
            </nav>
        </>
    );
};

export default Nav;
